/* ATR Studio v10: quick size add, favourites, filters, notify, design fee, requests, carousel */
(function () {
  var FAV_KEY = 'atr:favourites';
  var ENQ_KEY = 'atr:enquiry-item';
  var REQ_KEY = 'atr:requests';
  var notifyOpener = null;

  function readJSON(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      return parsed === null || parsed === undefined ? fallback : parsed;
    } catch (e) { return fallback; }
  }
  function writeJSON(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  var toastEl = null;
  function toast(message, linkText, linkHref) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'atr-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var text = document.createElement('span');
    text.textContent = message;
    toastEl.appendChild(text);
    if (linkText && linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      toastEl.appendChild(a);
    }
    toastEl.classList.add('show');
    window.clearTimeout(toastEl._t);
    toastEl._t = window.setTimeout(function () { toastEl.classList.remove('show'); }, 4200);
  }

  /* favourites */
  function paintFavs() {
    var favs = readJSON(FAV_KEY, []);
    if (!Array.isArray(favs)) favs = [];
    document.querySelectorAll('[data-atr-fav]').forEach(function (btn) {
      var on = favs.indexOf(btn.getAttribute('data-atr-fav')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (btn.dataset.labelOn && btn.dataset.labelOff) {
        var label = btn.querySelector('[data-atr-fav-text]');
        if (label) label.textContent = on ? btn.dataset.labelOn : btn.dataset.labelOff;
      }
    });
    document.querySelectorAll('[data-atr-fav-count]').forEach(function (el) {
      el.textContent = favs.length ? ' (' + favs.length + ')' : '';
    });
  }

  function toggleFav(handle) {
    var favs = readJSON(FAV_KEY, []);
    if (!Array.isArray(favs)) favs = [];
    var i = favs.indexOf(handle);
    if (i === -1) { favs.push(handle); } else { favs.splice(i, 1); }
    writeJSON(FAV_KEY, favs);
    paintFavs();
    renderSaved();
    return i === -1;
  }

  function renderSaved() {
    var grid = document.querySelector('[data-atr-saved-grid]');
    if (!grid) return;
    var favs = readJSON(FAV_KEY, []);
    if (!Array.isArray(favs)) favs = [];
    var shown = 0;
    grid.querySelectorAll('[data-atr-card]').forEach(function (card) {
      var on = favs.indexOf(card.getAttribute('data-handle')) !== -1;
      card.hidden = !on;
      if (on) shown += 1;
    });
    var empty = document.querySelector('[data-atr-saved-empty]');
    if (empty) empty.hidden = shown > 0;
    grid.classList.remove('is-loading');
  }

  /* custom requests */
  function readRequests() {
    var list = readJSON(REQ_KEY, []);
    return Array.isArray(list) ? list : [];
  }
  function saveRequest(item) {
    var list = readRequests();
    list.unshift({ item: item || 'Custom order', date: Date.now(), status: 'confirmed' });
    writeJSON(REQ_KEY, list.slice(0, 12));
  }
  function markLatestRequest(status) {
    var list = readRequests();
    if (!list.length) return;
    list[0].status = status;
    writeJSON(REQ_KEY, list);
  }
  function renderRequests() {
    var host = document.querySelector('[data-atr-requests]');
    if (!host) return;
    var list = readRequests();
    host.innerHTML = '';
    list.forEach(function (req) {
      var li = document.createElement('li');
      li.className = 'atr-request';
      var name = document.createElement('span');
      name.className = 'atr-request-item';
      name.textContent = req.item || 'Custom order';
      var meta = document.createElement('span');
      meta.className = 'atr-request-meta';
      var d = new Date(req.date);
      meta.textContent = isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
      var status = document.createElement('span');
      status.className = 'atr-request-status';
      status.textContent = req.status === 'confirmed' ? 'Enquiry received, awaiting our reply' : req.status === 'fee' || req.status === 'checkout' ? 'Payment opened — check your confirmation email' : 'Previous enquiry — check your confirmation email';
      li.appendChild(name);
      li.appendChild(meta);
      li.appendChild(status);
      host.appendChild(li);
    });
    var empty = document.querySelector('[data-atr-requests-empty]');
    if (empty) empty.hidden = list.length > 0;
  }

  /* quick add to cart */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-atr-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count ? ' (' + cart.item_count + ')' : '';
          const link=el.closest('.nav-cart');if(link)link.setAttribute('aria-label','Cart, '+cart.item_count+' items');
        });
      })
      .catch(function () {});
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-variant');
    if (!id || btn.disabled) return;
    var original = btn.textContent;
    var originalMarkup = btn.innerHTML;
    var quickPanel=btn.closest('details');
    var returnFocus=quickPanel && quickPanel.contains(document.activeElement);
    btn.disabled = true;
    btn.setAttribute('aria-busy','true');
    btn.textContent = btn.classList.contains('atr-direct-cart') ? '…' : 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (!res.ok) {
          btn.innerHTML=originalMarkup;
          if(returnFocus && quickPanel.open && document.activeElement===document.body)btn.focus();
          toast(res.data && res.data.description ? res.data.description : 'Could not add that one.');
          return;
        }
        if(quickPanel){var restore=returnFocus && (document.activeElement===document.body || quickPanel.contains(document.activeElement));quickPanel.open=false;if(restore)quickPanel.querySelector('summary').focus();}
        btn.innerHTML = originalMarkup;
        updateCartCount();
        var name = btn.getAttribute('data-name') || 'Added';
        toast(name + ' added' + (original && original.length <= 4 ? ' (' + original + ')' : ''), 'View cart', '/cart');
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');btn.innerHTML=originalMarkup;
        if(returnFocus && quickPanel.open && document.activeElement===document.body)btn.focus();
        toast('Network error. Please try again.');
      });
  }

  /* collection filters */
  function applyFilters(root) {
    var scope = document.querySelector(root.getAttribute('data-atr-filters'));
    if (!scope) return;
    var size = root.dataset.size || '';
    var band = root.dataset.price || '';
    var shown = 0;
    scope.querySelectorAll('[data-atr-card]').forEach(function (card) {
      var sizes = (card.getAttribute('data-sizes') || '').split(',').map(function (s) { return s.trim().toLowerCase(); });
      var price = parseFloat(card.getAttribute('data-price') || '0');
      var noSizeFilter = card.getAttribute('data-no-size-filter') === 'true';
      var okSize = !size || noSizeFilter || sizes.indexOf(size.toLowerCase()) !== -1;
      var okPrice = true;
      if (band) {
        var parts = band.split('-');
        var min = parseFloat(parts[0]);
        var max = parts[1] ? parseFloat(parts[1]) : Infinity;
        okPrice = price >= min && price <= max;
      }
      var visible = okSize && okPrice;
      card.hidden = !visible;
      if (visible) shown += 1;
    });
    scope.querySelectorAll('.atr-shop-row').forEach(function(row) { row.hidden = !Array.from(row.querySelectorAll('[data-atr-card]')).some(function(card) { return !card.hidden; }); });
    scope.querySelectorAll('.shop').forEach(function(track) { track.scrollLeft=0; });
    window.dispatchEvent(new Event('resize'));
    root.querySelectorAll('[data-atr-chip]').forEach(function (chip) {
      var group = chip.getAttribute('data-group');
      var active = (group === 'size' ? size : band) === chip.getAttribute('data-value');
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var count = root.querySelector('[data-atr-filter-count]');
    if (count) count.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
    var empty = scope.parentNode ? scope.parentNode.querySelector('[data-atr-filter-empty]') : null;
    if (empty) empty.hidden = shown > 0;
    var clear = root.querySelector('[data-atr-filter-clear]');
    if (clear) clear.hidden = !size && !band;
  }

  /* carousels */
  function initCarousel(root) {
    if (root.dataset.atrInit) return;
    root.dataset.atrInit = '1';
    var track = root.querySelector('[data-atr-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-atr-carousel-prev]');
    var next = root.querySelector('[data-atr-carousel-next]');
    function step() {
      var cell = track.firstElementChild;
      return cell ? cell.getBoundingClientRect().width + 10 : 200;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      root.classList.toggle('is-scrollable', max > 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* notify when back in stock */
  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function openNotify(productName, opener) {
    var modal = document.getElementById('atr-notify-modal');
    if (!modal) return;
    notifyOpener = opener || document.activeElement;
    modal.hidden = false;
    var field = modal.querySelector('[data-atr-notify-product]');
    if (field) field.value = productName || '';
    var label = modal.querySelector('[data-atr-notify-name]');
    if (label) label.textContent = productName || 'this piece';
    var email = modal.querySelector('input[type="email"]');
    if (email) window.setTimeout(function () { email.focus(); }, 40);
  }
  function closeNotify() {
    var modal = document.getElementById('atr-notify-modal');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (notifyOpener && typeof notifyOpener.focus === 'function') notifyOpener.focus();
    notifyOpener = null;
  }

  var pendingFeeHref = '';
  function openFeeConfirm(name, price, href) {
    var modal = document.getElementById('atr-fee-confirm-modal');
    if (!modal) return;
    pendingFeeHref = href || '';
    var nameEl = modal.querySelector('[data-atr-fee-confirm-name]');
    if (nameEl) nameEl.textContent = name || 'this option';
    var priceEl = modal.querySelector('[data-atr-fee-confirm-price]');
    if (priceEl) priceEl.textContent = price || '';
    modal.hidden = false;
  }
  function closeFeeConfirm() {
    var modal = document.getElementById('atr-fee-confirm-modal');
    if (modal) modal.hidden = true;
    pendingFeeHref = '';
  }
  function trapNotifyTab(event) {
    var modal = document.getElementById('atr-notify-modal');
    if (!modal || modal.hidden || event.key !== 'Tab') return;
    var focusable = getFocusable(modal);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
  function initNotifyForm() {
    var form = document.getElementById('atr-notify-form');
    if (form && !form.dataset.atrInit) {
      form.dataset.atrInit = '1';
      form.addEventListener('submit', function () {
        var field = form.querySelector('[data-atr-notify-product]');
        try { window.localStorage.setItem('atr:notify-pending', (field && field.value) || '1'); } catch (e) {}
      });
    }
    var pending = null;
    try { pending = window.localStorage.getItem('atr:notify-pending'); } catch (e) {}
    if (pending && window.location.search.indexOf('contact_posted=true') !== -1) {
      try { window.localStorage.removeItem('atr:notify-pending'); } catch (e) {}
      var name = pending === '1' ? 'that piece' : pending;
      toast('Noted. We will email you when ' + name + ' is back.');
    }
  }

  /* enquiry and design fee */
  var ENQ_DRAFT_FIELDS = ['enq-phone', 'enq-dest', 'enq-item', 'enq-qty', 'enq-date'];
  function initEnquiry() {
    var select = document.getElementById('enq-item');
    if (select && !select.dataset.atrInit) {
      select.dataset.atrInit = '1';
      var form = select.closest('form');
      if (form) {
        // Shopify's contact-form object only round-trips name/email/body on error;
        // everything else would otherwise be silently wiped on a validation failure.
        // Piggyback on the existing atr:enquiry-pending payload (already used to log
        // the request once it succeeds) to also carry a full draft for error-recovery
        // and for the post-success recap line.
        form.addEventListener('submit', function () {
          try { window.localStorage.setItem(ENQ_KEY, select.value || ''); } catch (e) {}
          var draft = { item: select.value || 'Custom order', at: Date.now() };
          ENQ_DRAFT_FIELDS.forEach(function (id) {
            var field = document.getElementById(id);
            if (field) draft[id] = field.value;
          });
          try { window.sessionStorage.setItem('atr:enquiry-pending', JSON.stringify(draft)); } catch (e) {}
        });
      }
    }
    var pending = null;
    try { pending = JSON.parse(window.sessionStorage.getItem('atr:enquiry-pending') || 'null'); } catch (e) {}
    var freshPending = pending && Date.now() - pending.at < 30 * 60 * 1000;
    if (freshPending && document.querySelector('[data-atr-enquiry-success]')) {
      var recap = document.querySelector('[data-atr-enquiry-recap]');
      if (recap) {
        var parts = [];
        if (pending['enq-dest']) parts.push(pending['enq-dest']);
        if (pending['enq-item']) parts.push(pending['enq-item']);
        if (pending['enq-qty']) parts.push(pending['enq-qty'] + ' people');
        if (parts.length) { recap.textContent = parts.join(' · '); recap.hidden = false; }
      }
    } else if (freshPending && document.querySelector('.form-msg[role="alert"]')) {
      ENQ_DRAFT_FIELDS.forEach(function (id) {
        var field = document.getElementById(id);
        if (!field || !pending[id]) return;
        if (field.tagName === 'SELECT' || !field.value) field.value = pending[id];
      });
    }
    if (pending && new URLSearchParams(window.location.search).get('atr_enquiry') === '1' && document.querySelector('[data-atr-enquiry-success]') && Date.now() - pending.at < 30 * 60 * 1000) {
      saveRequest(pending.item);
      try { window.sessionStorage.removeItem('atr:enquiry-pending'); } catch (e) {}
    }
    var fee = document.querySelector('[data-atr-fee]');
    if (fee && !fee.dataset.atrInit) {
      fee.dataset.atrInit = '1';
      var chosen = '';
      try { chosen = (window.localStorage.getItem(ENQ_KEY) || '').toLowerCase(); } catch (e) {}
      var key = '';
      if (chosen) {
        var hasTee = chosen.indexOf('tee') !== -1 || chosen.indexOf('t-shirt') !== -1;
        var hasCap = chosen.indexOf('cap') !== -1;
        if (hasTee && hasCap) key = 'combo';
        else if (hasCap) key = 'cap';
        else if (hasTee) key = 'tee';
      }
      if (key) {
        var match = fee.querySelector('[data-atr-fee-key="' + key + '"]');
        if (match) {
          match.classList.add('is-match');
          var flag = match.querySelector('[data-atr-fee-flag]');
          if (flag) flag.hidden = false;
          var options = fee.querySelector('.atr-fee-options');
          if (options && options.firstChild !== match) options.insertBefore(match, options.firstChild);
        }
      }
      fee.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  /* wiring */
  function init() {
    paintFavs();
    renderSaved();
    renderRequests();
    initEnquiry();
    initNotifyForm();
    document.querySelectorAll('[data-atr-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-atr-filters]').forEach(applyFilters);

    if (!document.body.dataset.atrV10) {
      document.body.dataset.atrV10 = '1';

      document.addEventListener('click', function (event) {
        var fav = event.target.closest('[data-atr-fav]');
        if (fav) {
          event.preventDefault();
          var added = toggleFav(fav.getAttribute('data-atr-fav'));
          toast(added ? 'Saved to your list.' : 'Removed from your list.', 'View saved', '/pages/saved');
          return;
        }

        var size = event.target.closest('.atr-quick-size');
        if (size) {
          event.preventDefault();
          quickAdd(size);
          return;
        }

        var chip = event.target.closest('[data-atr-chip]');
        if (chip) {
          event.preventDefault();
          var root = chip.closest('[data-atr-filters]');
          if (root) {
            var group = chip.getAttribute('data-group');
            var value = chip.getAttribute('data-value');
            var current = group === 'size' ? (root.dataset.size || '') : (root.dataset.price || '');
            var nextValue = current === value ? '' : value;
            if (group === 'size') { root.dataset.size = nextValue; } else { root.dataset.price = nextValue; }
            applyFilters(root);
          }
          return;
        }

        var clear = event.target.closest('[data-atr-filter-clear]');
        if (clear) {
          event.preventDefault();
          var froot = clear.closest('[data-atr-filters]');
          if (froot) { froot.dataset.size = ''; froot.dataset.price = ''; applyFilters(froot); }
          return;
        }

        var feeOption = event.target.closest('[data-atr-fee-key]');
        if (feeOption) {
          event.preventDefault();
          markLatestRequest('checkout');
          var priceEl = feeOption.querySelector('.atr-fee-price');
          openFeeConfirm(
            feeOption.getAttribute('data-atr-fee-label'),
            priceEl ? priceEl.textContent : '',
            feeOption.getAttribute('href')
          );
          return;
        }

        if (event.target.closest('[data-atr-fee-confirm-go]')) {
          event.preventDefault();
          if (pendingFeeHref) window.location.href = pendingFeeHref;
          return;
        }

        if (event.target.closest('[data-atr-fee-confirm-close]')) {
          event.preventDefault();
          closeFeeConfirm();
          return;
        }

        var notify = event.target.closest('[data-atr-notify]');
        if (notify) {
          if (!notify || notify.hidden || notify.disabled) return;
    const form = notify.closest('.product-info')?.querySelector('[data-atr-product-form]');
    if (form) {
      const variants = JSON.parse(form.querySelector('[data-atr-variants]').textContent);
      const selected = variants.find(v => String(v.id) === form.querySelector('[data-atr-variant-id]').value);
      if (!selected || selected.available) return;
    }
          event.preventDefault();
          openNotify(notify.getAttribute('data-atr-notify'), notify);
          return;
        }

        if (event.target.closest('[data-atr-notify-close]')) {
          event.preventDefault();
          closeNotify();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { closeNotify(); closeFeeConfirm(); }
        trapNotifyTab(event);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


